import { render, staticRenderFns } from "./IconArrowsExpandSolid.vue?vue&type=template&id=281550b1"
import script from "./IconArrowsExpandSolid.vue?vue&type=script&lang=js"
export * from "./IconArrowsExpandSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports